import styled from "styled-components";

export const Container = styled.div`
  /* width: 100%; */
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.24);
`;
